import React, { useMemo, useState } from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import ReactTooltip from "react-tooltip";
import useActiveSpecialistRole from "../../../app/hooks/useActiveSpecialistRole";
import { normalizeSpecialistRoleKey } from "../../../app/helpers/activeSpecialistRoleHelper";
import { resolveRecordExcelRoleKey } from "../../../app/helpers/flowEngineConfigHelper";
import RecordExcelUpdateModal from "./RecordExcelUpdateModal";

const RecordExcelUpdateHeaderButton = ({
  moduleProcess,
  expectedName,
  expectedId,
  onApplied,
  disabled = false,
  subjectKind = "",
  casePhase = ""
}) => {
  const { t } = useTranslation();
  const configuration = useSelector((state) => state.configuration);
  const { roleKey, availableRoles } = useActiveSpecialistRole();
  const extraRoleKeys = useMemo(
    () => availableRoles.map((role) => role.roleKey || normalizeSpecialistRoleKey(role)).filter(Boolean),
    [availableRoles]
  );
  const excelRoleKey = resolveRecordExcelRoleKey(configuration, moduleProcess, roleKey, extraRoleKeys);
  const [isOpen, setIsOpen] = useState(false);

  if (!excelRoleKey || (!expectedName && !expectedId)) {
    return null;
  }

  const tipId = `record-excel-header-${moduleProcess}`;

  return (
    <div className="d-flex justify-content-end">
      <button
        type="button"
        className="table-button-excel"
        data-tip
        data-for={tipId}
        disabled={disabled}
        aria-label={t("record-excel-update.title")}
        onClick={() => {
          if (!disabled) {
            setIsOpen(true);
          }
        }}
      >
        <i className="fa fa-file-excel fa-2x" />
      </button>
      <ReactTooltip id={tipId} place="bottom" effect="solid">
        {disabled
          ? t("record-excel-update.disabled", "No se puede actualizar desde Excel mientras el registro no es editable")
          : t("record-excel-update.title")}
      </ReactTooltip>
      <RecordExcelUpdateModal
        isOpen={isOpen}
        toggle={() => setIsOpen(false)}
        moduleProcess={moduleProcess}
        expectedName={expectedName}
        expectedId={expectedId}
        roleKey={excelRoleKey}
        subjectKind={subjectKind}
        casePhase={casePhase}
        onApplied={onApplied}
      />
    </div>
  );
};

RecordExcelUpdateHeaderButton.propTypes = {
  moduleProcess: PropTypes.string.isRequired,
  expectedName: PropTypes.string,
  expectedId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onApplied: PropTypes.func,
  disabled: PropTypes.bool,
  subjectKind: PropTypes.string,
  casePhase: PropTypes.string
};

export default RecordExcelUpdateHeaderButton;
